import { Dialog } from '@headlessui/react';
import { AlertCircle } from 'lucide-react';

interface CountryNotAvailableModalProps {
    isOpen: boolean;
    onClose: () => void;
    countryName: string;
}

export default function CountryNotAvailableModal({ isOpen, onClose, countryName }: CountryNotAvailableModalProps) {
    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-[110]">
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="mx-auto max-w-md w-full rounded-2xl bg-white p-6 shadow-xl">
                    <div className="flex items-start gap-3 mb-4">
                        <div className="p-2 bg-yellow-50 rounded-lg">
                            <AlertCircle className="w-6 h-6 text-yellow-600" />
                        </div>
                        <div className="flex-1">
                            <Dialog.Title className="text-xl font-semibold text-gray-900">
                                Currently US Only
                            </Dialog.Title>
                        </div>
                    </div>

                    <p className="text-sm text-gray-700 mb-4">
                        Unfortunately we are currently only available in the US. We have noted that you selected <span className="font-semibold">{countryName}</span>. We will get back to you as soon as possible when this country is available.
                    </p>

                    <p className="text-sm text-gray-700 mb-6">
                        Apologies for the inconvenience. We are working hard to add more countries for creators.
                    </p>

                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition-colors"
                        >
                            Got it
                        </button>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}

